import React from "react";

const TeamsTables = ({ teams }) => {
  if (!teams || (!teams.division1?.length && !teams.division2?.length)) {
    return null;
  }

  const allTeams = [...(teams.division1 || []), ...(teams.division2 || [])];
  const isSingles = allTeams.every((team) => team.players?.length === 1);

  return (
    <div className="mt-6 w-full">
      {["division1", "division2"].map((divisionKey) => {
        const divisionTeams = teams[divisionKey];
        if (!divisionTeams?.length) return null;

        return (
          <div key={divisionKey} className="mb-8">
            <h3 className="text-lg font-bold mb-2">
              {divisionKey === "division1" ? "Division 1" : "Division 2"}
            </h3>
            <div className="overflow-x-auto rounded shadow">
              <table className="min-w-full text-sm bg-gray-800 text-white">
                <thead>
                  <tr className="bg-gray-700 text-amber-400">
                    <th className="px-4 py-2 text-left">Équipe</th>
                    <th className="px-4 py-2 text-left">Joueur 1</th>
                    {!isSingles && (
                      <th className="px-4 py-2 text-left">Joueur 2</th>
                    )}
                    <th className="px-4 py-2 text-right">Elo total</th>
                  </tr>
                </thead>
                <tbody>
                  {divisionTeams.map((team) => {
                    const [p1, p2] = team.players ?? [];
                    const totalRanking =
                      (p1?.ranking ?? 0) + (p2?.ranking ?? 0);

                    return (
                      <tr
                        key={`${divisionKey}-${team.teamNumber}`}
                        className="border-t border-gray-600 hover:bg-gray-700"
                      >
                        <td className="px-4 py-2 font-semibold">
                          Équipe {team.teamNumber}
                        </td>
                        <td className="px-4 py-2">{p1?.name ?? "-"}</td>
                        {!isSingles && (
                          <td className="px-4 py-2">{p2?.name ?? "-"}</td>
                        )}
                        <td className="px-4 py-2 font-bold text-green-300 text-right">
                          {totalRanking}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TeamsTables;
